import React from "react";

function SayiKumelerininOzellikleriIntro() {
  return <div>SayiKumelerininOzellikleriIntro</div>;
}

export default SayiKumelerininOzellikleriIntro;
